import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "toggle_sort",
  "use": "toggle_sort-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"toggle_sort\">\r\n<title>toggle_sort</title>\r\n<path d=\"M0 0h24v24H0z\" fill=\"none\" />\r\n<path d=\"M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol